import api from "./api";

// Capa de servicios API del dominio "flow builders" (flujos) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listFlowBuilders = (params) => api.get("/flowbuilders", { params });
export const getFlowBuilder = (id) => api.get(`/flowbuilders/${id}`);
export const createFlowBuilder = (payload) => api.post("/flowbuilders", payload);
export const updateFlowBuilder = (id, payload) =>
  api.put(`/flowbuilders/${id}`, payload);
export const deleteFlowBuilder = (id) => api.delete(`/flowbuilders/${id}`);

// Media (endpoint singular /flowbuilder/upload-media).
export const uploadFlowBuilderMedia = (formData) =>
  api.post("/flowbuilder/upload-media", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// Importador Typebot → Flow Builder (0422 T1). Solo administradores. El token de Typebot viaja en
// el cuerpo de la petición y el backend no lo guarda.
export const listTypebots = (payload) => api.post("/flowbuilder/import/typebot/listar", payload);
export const importTypebots = (payload) => api.post("/flowbuilder/import/typebot", payload);

// Borrador y publicación (0422 R4): el editor guarda borradores; el motor ejecuta lo publicado.
export const saveFlowDraft = (id, payload) => api.put(`/flowbuilders/${id}/draft`, payload);
export const discardFlowDraft = (id) => api.delete(`/flowbuilders/${id}/draft`);
export const getPublishImpact = (id) => api.get(`/flowbuilders/${id}/publish-impact`);
export const publishFlow = (id) => api.post(`/flowbuilders/${id}/publish`);

// Salud de los nodos webhook/IA (0422 R5): los que llevan fallos seguidos.
export const listFlowAlerts = () => api.get("/flowbuilder/alerts");

// Exportar flujos a un archivo e importarlo en otra instalación (0434 X1/I1).
export const exportFlows = (ids) => api.post("/flowbuilders/export", { ids });
export const importFlowsFile = (archivo, crear, opciones = {}) => {
  const fd = new FormData();
  fd.append("archivo", archivo, archivo.name || "flujos.json");
  fd.append("crear", String(crear));
  fd.append("opciones", JSON.stringify(opciones));
  return api.post("/flowbuilders/import", fd);
};
